import { useState, useEffect, type FormEvent } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { navItems } from './navItems';

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  const submitSearch = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    setMenuOpen(false);
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : '/search');
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `px-3 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
      isActive
        ? 'text-primary-700 bg-primary-50'
        : 'text-foreground-700 hover:text-primary-700 hover:bg-primary-50/70'
    }`;

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
            <span className="w-9 h-9 rounded-md bg-primary-600 text-background-50 flex items-center justify-center text-base font-black tracking-tight">
              51
            </span>
            <span className="flex flex-col leading-none">
              <span className="text-lg font-black text-foreground-950 tracking-tight">
                51每日大赛
              </span>
              <span className="hidden sm:block text-[11px] text-foreground-500 mt-0.5">
                每日黑榜 · 赛事资讯
              </span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink key={item.path} to={item.path} className={linkClass} end={item.path === '/'}>
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <form onSubmit={submitSearch} className="hidden lg:flex items-center relative">
              <i className="ri-search-line absolute left-3 text-foreground-400 text-sm"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索黑榜 / 资讯"
                className="w-52 xl:w-64 pl-9 pr-3 py-2 text-sm rounded-md bg-background-100 border border-background-300 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-colors"
              />
            </form>

            <Link
              to="/search"
              aria-label="搜索"
              className="lg:hidden w-9 h-9 flex items-center justify-center rounded-md text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer"
            >
              <i className="ri-search-line text-lg"></i>
            </Link>

            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              aria-label="菜单"
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-md text-foreground-800 hover:bg-primary-50 transition-colors cursor-pointer"
            >
              <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden fixed inset-x-0 top-16 bottom-0 z-40 bg-background-50 overflow-y-auto">
          <div className="px-4 py-4">
            <form onSubmit={submitSearch} className="flex items-center relative mb-4">
              <i className="ri-search-line absolute left-3 text-foreground-400 text-sm"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索黑榜 / 资讯"
                className="w-full pl-9 pr-3 py-3 text-sm rounded-md bg-background-100 border border-background-300 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400"
              />
            </form>
            <nav className="flex flex-col gap-1">
              {navItems.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  end={item.path === '/'}
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) =>
                    `px-4 py-3 rounded-md text-base font-medium transition-colors cursor-pointer ${
                      isActive
                        ? 'text-primary-700 bg-primary-50'
                        : 'text-foreground-800 hover:bg-primary-50/70'
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}